import type { UrlsPerCountry } from '@constants/countryDetails'
import { brazilUrl } from '@constants/countryDetails'
import { createNamedContext } from '@helpers/core/createNamedContext'

export const defaultPageVariations = {
  es: ['/es-es/', '/en-es/'],
  de: ['/en-de/', '/de-de/'],
  fr: ['/en-fr/', '/fr-fr/'],
  us: ['/en-us/'],
  gb: ['/en-gb/'],
  at: ['/en-at/', '/de-at/'],
  ch: ['/en-ch/', '/de-ch/'],
  br: [brazilUrl],
  eu: ['/en-eu/'],
  it: ['/en-it/', '/it-it/'],
  be: ['/en-be/', '/fr-be/'],
}

export type PageVariationsContextType = {
  localizedUrls: UrlsPerCountry
  setLocalizedUrls: React.Dispatch<React.SetStateAction<UrlsPerCountry>>
}

export const PageVariationsContext =
  createNamedContext<PageVariationsContextType>('PageVariationsContext', {
    localizedUrls: defaultPageVariations,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setLocalizedUrls: () => {},
  })
